import { render, staticRenderFns } from "./slimScroll.vue?vue&type=template&id=17f05bd0&"
import script from "./slimScroll.vue?vue&type=script&lang=js&"
export * from "./slimScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports